import { render } from "./Games.vue?vue&type=template&id=298874d2&scoped=true&ts=true"
import script from "./Games.vue?vue&type=script&lang=ts"
export * from "./Games.vue?vue&type=script&lang=ts"

import "./Games.vue?vue&type=style&index=0&id=298874d2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298874d2"]])

export default __exports__